import { Loader2 } from "lucide-react"

interface CardSkeletonProps {
  label: string
}

export function CardSkeleton({ label }: CardSkeletonProps) {
  return (
    <div className="my-2 flex items-center gap-2 rounded-lg border border-border/20 bg-background/5 p-3">
      <Loader2 className="h-4 w-4 animate-spin text-foreground/50" />
      <span className="text-xs text-foreground/50">{label}</span>
    </div>
  )
}
